<ion-header class="no-shadow">
  <ion-toolbar>
    <ion-title>Select Record</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close" class="font-size-16 m-l-10" style="vertical-align: middle; color: black;"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-card *ngFor="let record of records; let i = index" button (click)="selectRecord(i)"
      [class.selected]="selectedIndex === i" class="record-card">

      <ion-card-header>
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <ion-card-title style="color: #295396; font-size: 16px; margin: 0;">
            Option {{ i + 1 }}
          </ion-card-title>

          <!-- Right side icon (only visible when selected) -->
          <ion-icon *ngIf="selectedIndex === i" name="checkmark-circle" style="color: green; font-size: 22px;">
          </ion-icon>
        </div>
      </ion-card-header>


      <ion-card-content>
        <div class="record-wrapper">
          <div *ngFor="let field of record" class="record-line">
            <!-- Field Label -->
            <span class="color-netral-500 inter-regular font-size-16">
              {{ field.label?.en }}:
            </span>

            <!-- Case 1: Simple string value -->
            <span *ngIf="field.apiResponseKeyValue && !isArray(field.apiResponseKeyValue)"
              class="color-netral-700 inter-regular font-size-16">
              {{ field.apiResponseKeyValue || '-' }}
            </span>

            <!-- Case 2: Nested array (ctrl_buyers_parent case) -->
            <ng-container *ngIf="isArray(field.apiResponseKeyValue)">
              <ion-list>
                <ion-radio-group [disabled]="selectedIndex !== i"
                  [ngModel]="selectedNested[i] ? selectedNested[i][field.controlId] : null"
                  (ngModelChange)="onNestedSelect(i, field.controlId, $event)">

                  <ion-item *ngFor="let group of field.apiResponseKeyValue; let j = index">
                    <ion-radio slot="start" [value]="getGroupValue(group)" mode="md">
                    </ion-radio>
                    <ion-label>
                      <!-- Render all values in the group -->
                      <div *ngFor="let child of group">
                        <span class="color-netral-500 inter-regular font-size-16">
                          {{ child.label?.en }}:
                        </span>

                        <!-- Case 1: Simple string value -->
                        <span class="color-netral-700 inter-regular font-size-16">
                          {{ child.apiResponseKeyValue || '-' }}
                        </span>
                      </div>
                    </ion-label>
                  </ion-item>

                </ion-radio-group>
              </ion-list>
            </ng-container>
          </div>
        </div>
      </ion-card-content>

    </ion-card>

  </ion-list>
</ion-content>

<ion-footer class="white-background ion-text-center footer-style">
  <div fxLayout="row" fxLayoutAlign="space-evenly none" class="m-l-5">
    <div fxFlex="47">
      <ion-button class="nobackground show-fulltext h-48 font-size-18 t-c inter-medium letter-spacing-normal"
        expand="block" fill="outline" (click)="dismiss()">
        Close
      </ion-button>
    </div>
    <div fxFlex="47">
      <ion-button expand="block" data-testid="confirm-btn"
        class="t-c commonbtn show-fulltext h-48 font-size-18 inter-medium letter-spacing-normal"
        [disabled]="!isSelectionComplete()" (click)="confirmSelection()">
        ok
      </ion-button>

    </div>
  </div>
</ion-footer>